import { defineMessages } from "react-intl";

export default defineMessages({
  header: {
    id: "zQX6xO",
    defaultMessage: "Delete App",
    description: "dialog header",
  },
  deleteApp: {
    id: "6hLZNA",
    defaultMessage: "Are you sure you want to delete this app?",
    description: "delete app",
  },
  deleteNamedApp: {
    id: "/OdWW5",
    defaultMessage:
      "Deleting {name}, you will remove installation of the app. If you are paying for app subscription, remember to unsubscribe from the app in Siyool Marketplace. Are you sure you want to delete the app?",
    description: "delete app",
  },
});
